import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompensationFilterEntity } from '../../domain/entities/CompensationFilterEntity'

export class CompensationFilterModel extends CompensationFilterEntity {
  constructor(dataDto: CompensationFilterEntity) {
    super()
    mapEntityProperties<CompensationFilterEntity>(this, dataDto)
  }
}
